import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const PaginationCustom = styled.div`
  text-align: end;
`;

const CustomSelect = styled(Select)`
  .ant-select-selection-item {
    font-weight: bold;
  }
`;

function PageSizeOption({ label, pageSize, total, onChangePageSize }) {
  return (
    <PaginationCustom>
      {label}{' '}
      <CustomSelect
        value={pageSize}
        bordered={false}
        onChange={onChangePageSize}
        options={[
          {
            value: 8,
            label: `8 de ${total}`,
          },
          {
            value: 10,
            label: `10 de ${total}`,
          },
          {
            value: 20,
            label: `20 de ${total}`,
          },
          {
            value: 50,
            label: `50 de ${total}`,
          },
          {
            value: 100,
            label: `100 de ${total}`,
          },
        ]}
      />
    </PaginationCustom>
  );
}

PageSizeOption.propTypes = {
  label: PropTypes.string.isRequired,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onChangePageSize: PropTypes.func.isRequired,
};

export default PageSizeOption;
